// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"5b818f09","344":"137fbe71","453":"495483b8","841":"1b36736f"}[chunkId] + ".chunk.js";
};